import { c as _c } from "react/compiler-runtime";
import { usePersistedState } from "@justhome/common/hooks";
import { Button, Modal } from "@justhome/react-ui";
import type { NextRouter } from "next/router";
import { useRouter } from "@lib/hooks/useRouter";
import { FC, useState } from "react";
export interface LanguageModalProps {}
const LanguageModal: FC<LanguageModalProps> = () => {
  const $ = _c(27);
  const router = useRouter();
  const {
    pathname,
    asPath,
    query
  } = router;
  const [dismissedOnRouter, setDismissedOnRouter] = useState();
  const [languageModalDone, setLanguageModalDone, isHydrated] = usePersistedState("languageModalDone", false);
  let t0;
  if ($[0] !== dismissedOnRouter || $[1] !== isHydrated || $[2] !== languageModalDone || $[3] !== router) {
    t0 = isHydrated && !languageModalDone && dismissedOnRouter !== router && !navigator.language.startsWith("de") && router.locale != "en";
    $[0] = dismissedOnRouter;
    $[1] = isHydrated;
    $[2] = languageModalDone;
    $[3] = router;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const isModalOpen = t0;
  let t1;
  if ($[5] !== setLanguageModalDone) {
    t1 = function handleModalClose() {
      setLanguageModalDone(true);
    };
    $[5] = setLanguageModalDone;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const handleModalClose = t1;
  let t2;
  if ($[7] !== asPath || $[8] !== handleModalClose || $[9] !== pathname || $[10] !== query || $[11] !== router) {
    t2 = function handleChangeLanguage() {
      handleModalClose();
      router.replace({
        pathname,
        query
      }, asPath, {
        locale: "en"
      });
    };
    $[7] = asPath;
    $[8] = handleModalClose;
    $[9] = pathname;
    $[10] = query;
    $[11] = router;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const handleChangeLanguage = t2;
  let t3;
  if ($[13] !== router) {
    t3 = () => setDismissedOnRouter(router);
    $[13] = router;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span>We have noticed that your browser language is not German.<br />Would you like to switch to the English version of the page?</span>;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== handleChangeLanguage) {
    t5 = <Button variant="primary" size="md" onClick={handleChangeLanguage}>Go to English version</Button>;
    $[16] = handleChangeLanguage;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== handleModalClose) {
    t6 = <Button variant="ghost" size="md" onClick={handleModalClose}>Stay with German version</Button>;
    $[18] = handleModalClose;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t5 || $[21] !== t6) {
    t7 = <div className="flex flex-col gap-y-2s items-center mt-m">{t5}{t6}</div>;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== isModalOpen || $[24] !== t3 || $[25] !== t7) {
    t8 = <Modal isOpen={isModalOpen} setIsOpen={t3}>{t4}{t7}</Modal>;
    $[23] = isModalOpen;
    $[24] = t3;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
};
export default LanguageModal;